var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column"},[_c('buy-at-home'),_c('get-real-pricing'),_c('real-trade'),_c('finance'),_c('save-work')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }